// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SchematisationVectorMeta } from "./SchematisationVectorMeta";
import {
  SchematisationVectorMetaFromJSON,
  SchematisationVectorMetaFromJSONTyped,
  SchematisationVectorMetaToJSON,
  SchematisationVectorMetaToJSONTyped,
} from "./SchematisationVectorMeta";

/**
 *
 * @export
 * @interface SchematisationMeta
 */
export interface SchematisationMeta {
  /**
   *
   */
  id: number;
  /**
   *
   */
  revisionId?: number | null;
  /**
   *
   */
  vector?: SchematisationVectorMeta | null;
}

/**
 * Check if a given object implements the SchematisationMeta interface.
 */
export function instanceOfSchematisationMeta(value: object): value is SchematisationMeta {
  if (!("id" in value) || value["id"] === undefined) return false;
  return true;
}

export function SchematisationMetaFromJSON(json: any): SchematisationMeta {
  return SchematisationMetaFromJSONTyped(json, false);
}

export function SchematisationMetaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SchematisationMeta {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    revisionId:
      json["revision_id"] === undefined
        ? undefined
        : json["revision_id"] === null
        ? null
        : json["revision_id"],
    vector:
      json["vector"] === undefined
        ? undefined
        : json["vector"] === null
        ? null
        : SchematisationVectorMetaFromJSON(json["vector"]),
  };
}

export function SchematisationMetaToJSON(json: any): SchematisationMeta {
  return SchematisationMetaToJSONTyped(json, false);
}

export function SchematisationMetaToJSONTyped(
  value?: SchematisationMeta | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    revision_id: value["revisionId"],
    vector: SchematisationVectorMetaToJSON(value["vector"]),
  };
}
